import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChange, ViewChild} from '@angular/core';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';

declare var jQuery: any;

@Component({
    selector: 'itpx-combobox-single-select',
    templateUrl: './combobox-single-select.component.html',
    styleUrls: [ './combobox-single-select.component.css' ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ComboboxSingleSelectComponent),
            multi: true
        }
    ]
})
export class ComboboxSingleSelectComponent implements ControlValueAccessor, OnChanges, AfterViewInit {
    @Input() options: Array<any>;
    @Input() maxShownResults: string;
    @Input() disableSearch: string;
    @Input() placeholder: string;
    @Input('value') _value: any;
    @Input() emitInputVal: boolean;
    @Input() clearOptions: boolean;
    @Input() disableCombobox: boolean;
    @Input() resetCombobox: boolean;
    @ViewChild('comboboxSingleSelect') comboboxElement;
    @Output() combochange: EventEmitter<any> = new EventEmitter();
    propagateChange = (_: any) => {};

    private items: Array<string> = [];

    constructor(private sanitiser: DomSanitizer) {}

    ngAfterViewInit() {

        if(this.maxShownResults) {
            jQuery(this.comboboxElement.nativeElement).chosen({
                no_results_text: 'Oops, nothing found!',
                max_shown_results: this.maxShownResults,
                disable_search_threshold: this.disableSearch || 10,
                placeholder_text_single: this.placeholder || 'Select an Option'
            });
        } else {
            jQuery(this.comboboxElement.nativeElement).chosen({
                no_results_text: 'Oops, nothing found!',
                disable_search_threshold: this.disableSearch || 10,
                placeholder_text_single: this.placeholder || 'Select an Option'
            });
        }

        jQuery('.chosen-container-single .chosen-single').css({
            'height':'34px',
            'background':'white',
            'border': '1px solid #ccc'
        });
        jQuery('.chosen-container-single .chosen-single span').css({
            'line-height':'2.5',
            'padding-left': '6px',
            'font-size': '14px'
        });
        jQuery('.chosen-container-single .chosen-single div').css({
            'top':'3px',
            'right':'-3px'
        });

        jQuery(this.comboboxElement.nativeElement).on('change', this.onChange.bind(this));
    }

    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        if(changes['resetCombobox'] && this.resetCombobox) {
            this.value = null;
            this.items = [];
            jQuery(this.comboboxElement.nativeElement).val(this.items).trigger('chosen:updated');
        }
        if (changes['clearOptions'] && this.clearOptions) {
            jQuery(this.comboboxElement.nativeElement).empty();
        }
        if(changes['options'] && changes['options'].currentValue.length) {
            this.options.forEach((val) => {
                if(val && val.key){
                    val.key = val.key.toString();
                    // send option.value instead of option.key
                    if(this.emitInputVal) {
                        jQuery(this.comboboxElement.nativeElement).append(
                        '<option value=\''+ this.sanitiser.sanitize(1, val.value) +'\'>'+ this.sanitiser.sanitize(1, val.value) +'</option>'
                        );
                    } else {
                        jQuery(this.comboboxElement.nativeElement).append(
                        '<option value=\''+ this.sanitiser.sanitize(1, val.key) +'\'>'+ this.sanitiser.sanitize(1, val.value) +'</option>'
                        );
                    }
                }
            });
            if(this.items) {
                jQuery(this.comboboxElement.nativeElement).val(this.items).trigger('chosen:updated');
            }
        }
        if(changes['disableCombobox'] && this.disableCombobox) {
            jQuery(this.comboboxElement.nativeElement).attr('disabled', true).trigger('chosen:updated');
        } else {
            jQuery(this.comboboxElement.nativeElement).attr('disabled', false).trigger('chosen:updated')
        }


    }

    get value() {
        return this._value;
    }

    set value(val) {
        this.items = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.items = value;
        }
        jQuery(this.comboboxElement.nativeElement).val(this.items).trigger('chosen:updated');
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    private onChange(event: any, params: any) {
        if(params.selected) {
            this.items = params.selected;
        }
        this.value = this.items;
        this.combochange.emit(this.items);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/combobox-single-select/combobox-single-select.component.ts